export const BRAND_ASSETS = {
  fullDark: '/assets/brand/ablecomply-logo-full-clean-dark.png',
  fullLight: '/assets/brand/ablecomply-logo-full-light.svg',
  authFullLight: '/assets/brand/ablecomply-logo-full-auth-light.png',
  horizontalDark: '/assets/brand/ablecomply-logo-full-clean-dark.png',
  horizontalLight: '/assets/brand/ablecomply-logo-horizontal-light.svg',
  iconDark: '/assets/brand/ablecomply-logo-icon-dark.svg',
  iconLight: '/assets/brand/ablecomply-logo-icon-clean-light.png',
  monochromeDark: '/assets/brand/ablecomply-logo-monochrome-dark.svg',
  monochromeLight: '/assets/brand/ablecomply-logo-monochrome-light.svg',
  appIcon: '/assets/brand/ablecomply-app-icon.svg',
  appIconPng: '/assets/brand/ablecomply-app-icon.png',
  favicon: '/assets/brand/favicon.svg',
  favicon16: '/assets/brand/favicon-16.png',
  favicon32: '/assets/brand/favicon-32.png',
  favicon48: '/assets/brand/favicon-48.png',
  favicon64: '/assets/brand/favicon-64.png',
} as const;

export const BRAND_COLORS = {
  page: 'var(--brand-canvas)',
  pageElevated: 'var(--brand-canvas-elevated)',
  surface: 'var(--brand-white)',
  surfaceMuted: 'var(--brand-surface-muted)',
  surfaceStrong: 'var(--brand-surface-strong)',
  text: 'var(--brand-text)',
  textMuted: 'var(--brand-text-muted)',
  textSoft: 'var(--brand-text-soft)',
  border: 'var(--brand-border)',
  borderStrong: 'var(--brand-border-strong)',
  primary: 'var(--brand-navy)',
  primaryHover: 'var(--brand-navy-hover)',
  primaryPressed: 'var(--brand-navy-pressed)',
  primaryStrong: 'var(--brand-navy-strong)',
  primarySoft: 'var(--brand-navy-soft)',
  accent: 'var(--brand-teal)',
  accentSoft: 'var(--brand-teal-soft)',
  success: 'var(--acc-color-success)',
  successSoft: 'var(--acc-color-success-soft)',
  warning: 'var(--acc-color-warning)',
  warningSoft: 'var(--acc-color-warning-soft)',
  danger: 'var(--acc-color-danger)',
  dangerSoft: 'var(--acc-color-danger-soft)',
  info: 'var(--acc-color-info)',
  infoSoft: 'var(--acc-color-info-soft)',
  shell: 'var(--brand-shell)',
  shellElevated: 'var(--brand-shell-elevated)',
  shellBorder: 'var(--brand-shell-border)',
  shadow: 'var(--acc-shadow-soft)',
} as const;
